import { gql } from '@apollo/client'

export default gql(`
query getBucket($id: ID!) {
    getBucket(id: $id) {
        id
        updatedAt
    }
}`)
